























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Heading from '@/shared/components/Heading/Heading.vue';
import SecureSection from '@/shared/components/SecuredSection/SecuredSection.vue';
import PaymentMethods from './components/PaymentMethods/PaymentMethods.vue';
import DeliveryAddressMobile from './components/mobile/DeliveryAddressMobile/DeliveryAddressMobile.vue';
import SystemError from './components/ErrorSystem/SystemError.vue';

import OfferCard from '../Offer/components/OfferCard/OfferCard.vue';

import { EPaymentMethod, ECardStep, EEligibilityAction } from '@/helpers/enums';

import { ICheckoutCartOfferEligibility, ICheckout, IInvoice, ICheckoutCartOffer } from '@/interfaces/Checkout';
import { IPayment } from '@/interfaces/Payment';
import { Payment } from '@/classes/Checkout/Payment';

const BehaviorModule = namespace('App/Behavior');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    OfferCard,
    Heading,
    SecureSection,
    PaymentMethods,
    DeliveryAddressMobile,
    SystemError,
  }
})
export default class PaymentMobile extends Vue {
  @CheckoutModule.Getter('isAddressRequired')
  private isAddressRequired: boolean;

  private get ABSecurity() {
    return this.$route.query.s === '1';
  }

  private get showMessageErrorSystem(){
    return process.env.VUE_APP_ENABLE_PAYMENT_MESSAGE_ERROR_SYSTEM === 'true';
  }

  private get paymentText(): string {
    return this.isEmpiricusGift ? 'Seja bem-vindo à Empiricus' : 'Como deseja pagar?';
  }

  private get isEmpiricusGift() {
    return this.$route.query.g === '1';
  }
}
